/**
 * ビューポートがスマホ幅かどうかを判定（Tailwindのsm未満 <640px を基準）
 */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return false;
  return window.matchMedia('(max-width: 639px)').matches;
}
